<template>
  <MobileLayout>
    <MobileHeader :logoColor="'white'" />
    
    <section class="m-hero font-apercu-medium">
      <img :src="founder1" alt="Founder" class="m-hero-img" />
      <div class="m-hero-overlay">
        <div class="m-hero-subtitle" style="line-height: 6rem;">Founder</div>
        <div class="m-hero-title" style="line-height: 12rem;">Steven John Clark</div>
      </div>
    </section>

    <section class="m-text-block font-apercu-medium">
      <p style="text-align: justify;">Steven John Clark is an artist and designer whose work has never followed a particularly straight line. Astonemason before studying fashion, sculptor and designer, his approach is instinctive but deeply informed, builtover decades of working across disciplines processes and materials.</p>
    </section>
    
	
	
    <section class="m-image-block">
      <img :src="founder2" alt="Founder Hands" />
    </section>
	
    <section class="m-text-block font-apercu-medium">
      <p  style="text-align: justify;">Founded in 2016, denHolm grew out of that somewhat unconventional path. Steven brings to each piece theknowledge of a stonemason and the curiosity of someone who has never been especially interested in doing things
the expected way.</p>
    </section>
	
    <section class="m-image-block m-image-block2">
      <img :src="founder3" alt="Founder Workshop" />
    </section>

    <section class="m-text-block font-apercu-medium">
      <p style="text-align: justify;">For him, craftsmanship is not something applied at the end, but where the thinking begins. Every piece he made is
considered without being overly polite, precise without becoming predictable, and always recognisably his.</p>
    </section>

    <section class="m-slider-block">
      <div class="m-slider-track">
        <div class="m-slider-item">
          <img :src="lb1" alt="Working" />
        </div>
        <div class="m-slider-item">
          <img :src="lb2" alt="Sketches" />
        </div>
        <div class="m-slider-item">
          <img :src="lb3" alt="Sketches" />
        </div>
      </div>
    </section>

    <section class="m-quote-block font-bespoke-italic">
      <p class="m-quote-text font-apercu-medium">“I don’t see myself working in the same medium for the rest of my life. The one simple fact of what makes me happy is that I know I can create.”</p>
      <p class="m-quote-author font-apercu-medium">Steven John Clark</p>
    </section>

    <section class="m-image-block" style="height: 555rem;">
      <img :src="founder5" alt="Founder Yellow"  />
    </section>

    <MobileFooter :mt="50" :isBorder="false" style="margin-bottom: 80rem;" />
  </MobileLayout>
</template>

<script>
import MobileLayout from '@/components/mobile/MobileLayout.vue'
import MobileFooter from '@/components/mobile/footer.vue'
import MobileHeader from '@/components/mobile/header.vue'

const founder1 = require('@/assets/founder/founder1.jpg')
const founder2 = require('@/assets/founder/founder2.jpg')
const founder3 = require('@/assets/founder/founder3.jpg')
const founder4 = require('@/assets/founder/founder4.jpg')
const founder5 = require('@/assets/mobile/founder/db.jpg')
const lb1 = require('@/assets/mobile/founder/1.jpg')
const lb2 = require('@/assets/mobile/founder/2.jpg')
const lb3 = require('@/assets/mobile/founder/3.jpg')
const founderSlip = require('@/assets/founder/founder_slip.png')
const brandLogo = require('@/assets/mobile/home/logo.png')

export default {
  name: 'MobileFounder',
  components: {
    MobileLayout,
    MobileFooter,
    MobileHeader
  },
  data() {
    return {
      founder1,
      founder2,
      founder3,
      founder4,
      founder5,
	  lb1,
	  lb2,
	  lb3,
      founderSlip,
      brandLogo
    }
  }
}
</script>

<style scoped>
.m-hero {
  position: relative;
  height: 535rem;
  width: 100%;
}

.m-hero-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.m-hero-overlay {
  position: absolute;
  bottom: 40rem;
  left: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  z-index: 10;
}

.m-hero-subtitle {
  font-size: 8rem;
  margin-bottom: 5rem;
  font-weight: 500;
}

.m-hero-title {
  font-size: 16rem;
  font-weight: 700;
}

.m-text-block {
  padding: 40rem 20rem;
  font-size: 8rem;
  text-align: left;
}

.m-image-block {
  width: 100%;
  height: 454rem;
  margin-bottom: 9rem;
  padding: 0 16rem;
}

.m-image-block2 {
  height: 277rem;
  margin-bottom: 0rem !important;
}

.m-image-block img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.m-slider-block {
  width: 100%;
  margin-bottom: 40rem;
  overflow: hidden;
}

.m-slider-track {
  display: flex;
  overflow-x: auto;
  padding: 0 16rem;
  gap: 10rem;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.m-slider-track::-webkit-scrollbar {
  display: none;
}

.m-slider-item {
  flex: 0 0 auto;
  scroll-snap-align: start;
}

.m-slider-item img {
  width: 215rem;
  height: 270rem;
  object-fit: cover;
  display: block;
}

.m-quote-block {
  padding: 0 30rem 40rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.m-quote-text {
  font-size: 8rem;
  margin-bottom: 10rem;
}

.m-quote-author {
  font-size: 8rem;
  /* font-style: italic; */
}
</style>
